import { StyleSheet, css } from 'aphrodite';
import React, { ReactNode } from 'react';

import { c } from '@/app/providers/theme-provider/ThemeProvider';

type Props = {
  children?: ReactNode;
};

export default function EmbeddedToolbarShell({ children }: Props) {
  return <div className={css(styles.toolbar)}>{children}</div>;
}

const styles = StyleSheet.create({
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 4,
    height: 48,
    backgroundColor: c('content'),
    borderBottom: `1px solid ${c('border')}`,
    color: c('text'),
  },
});
